<template>
  <w-icon-wrapper
    :height='24'
    :width='20.572'
    icon-name='work-nav-working-time-managment-icon'
    view-box='0 0 20.572 24'
  >
    <path
      id="_02_Arbeitszeitmanagement_Icon"
      data-name="02_Arbeitszeitmanagement_Icon"
      d="M126.857-917.714V-920h6.857v2.286Zm2.286,12.571h2.286V-912h-2.286ZM130.286-896a9.881,9.881,0,0,1-3.986-.814,10.508,10.508,0,0,1-3.271-2.214,10.506,10.506,0,0,1-2.214-3.271,9.881,9.881,0,0,1-.814-3.986,9.881,9.881,0,0,1,.814-3.986,10.506,10.506,0,0,1,2.214-3.271,10.506,10.506,0,0,1,3.271-2.214,9.881,9.881,0,0,1,3.986-.814,10.194,10.194,0,0,1,3.4.571,11.112,11.112,0,0,1,3.057,1.657l1.6-1.6,1.6,1.6-1.6,1.6A11.112,11.112,0,0,1,140-909.686a10.194,10.194,0,0,1,.571,3.4,9.881,9.881,0,0,1-.814,3.986,10.506,10.506,0,0,1-2.214,3.271,10.508,10.508,0,0,1-3.271,2.214A9.881,9.881,0,0,1,130.286-896Zm0-2.286a7.708,7.708,0,0,0,5.657-2.343,7.708,7.708,0,0,0,2.343-5.657,7.708,7.708,0,0,0-2.343-5.657,7.708,7.708,0,0,0-5.657-2.343,7.708,7.708,0,0,0-5.657,2.343,7.708,7.708,0,0,0-2.343,5.657,7.708,7.708,0,0,0,2.343,5.657A7.708,7.708,0,0,0,130.286-898.286ZM130.286-906.286Z"
      transform="translate(-120 920)"
      fill="currentColor"
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconNavWorkingTimeManagment' };
</script>
